import { useGetCaseOptionsQuery } from 'queries/cases/queries';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInput, FormSelect } from 'ui/FormComponents';
import { SelectOptionsArrayMapper } from 'utils/ArrayUtil';

export const SavingsForm = () => {
  const { t } = useTranslation();
  const { data } = useGetCaseOptionsQuery();
  const savingsOptions = data?.savings;
  const savings = useWatch({
    name: 'savings',
  });

  if (!savingsOptions) return null;

  const { equipment_class, subunit } = savings;

  const subunitOptions =
    savingsOptions && equipment_class && equipment_class !== 'None'
      ? savingsOptions.equipment_class[equipment_class as string]
      : {};

  const maintainableOptions =
    subunit && subunit !== 'None' ? subunitOptions[subunit as string] : [];

  return (
    <section data-testid="savings-form">
      <div className="columns is-variable is-2">
        <div className="column is-two-thirds">
          <FormInput
            data-testid="savings-description-input"
            name="savings.description"
            label={t('case:inputs.description')}
            placeHolderText={t('case:placeholders.savings_description')}
          />
        </div>

        <div className="column is-one-third">
          <FormInput
            data-testid="savings-total-estimated-input"
            name="savings.total_estimated"
            label={t('case:inputs.total_estimated_cost')}
            placeHolderText={t('case:placeholders.enter_value')}
          />
        </div>
      </div>

      <div className="columns is-variable is-2">
        <div className="column is-one-third">
          <FormSelect
            data-testid="savings-equipment-class-select"
            name="savings.equipment_class"
            label={t('case:inputs.equipment_class')}
            placeHolderText={t('case:placeholders.selectAnOption')}
            selectOptionData={[
              ...SelectOptionsArrayMapper(Object.keys(savingsOptions.equipment_class)),
            ]}
          />
        </div>

        <div className="column is-one-third">
          <FormSelect
            data-testid="savings-subunit-select"
            name="savings.subunit"
            label={t('case:inputs.subunit')}
            placeHolderText={t('case:placeholders.selectAnOption')}
            selectOptionData={[...SelectOptionsArrayMapper(Object.keys(subunitOptions))]}
          />
        </div>

        <div className="column is-one-third">
          <FormSelect
            data-testid="savings-maintainable-item-select"
            name="savings.maintainable_item"
            label={t('case:inputs.maintainable_item')}
            placeHolderText={t('case:placeholders.selectAnOption')}
            selectOptionData={SelectOptionsArrayMapper(maintainableOptions)}
          />
        </div>
      </div>

      <div className="columns is-variable is-2">
        <div className="column is-one-third">
          <FormSelect
            data-testid="savings.failure_mode-select"
            name="savings.failure_mode"
            label={t('case:inputs.failure_mode')}
            placeHolderText={t('case:placeholders.selectAnOption')}
            selectOptionData={[...SelectOptionsArrayMapper(savingsOptions.failure_mode)]}
          />
        </div>

        <div className="column is-one-third">
          <FormSelect
            data-testid="savings.failure_mechanism-select"
            name="savings.failure_mechanism"
            label={t('case:inputs.failure_mechanism')}
            placeHolderText={t('case:placeholders.selectAnOption')}
            selectOptionData={SelectOptionsArrayMapper(savingsOptions.failure_mechanism)}
          />
        </div>

        <div className="column is-one-third">
          <FormSelect
            data-testid="savings.maintenance_scope-select"
            name="savings.maintenance_scope"
            label={t('case:inputs.maintenance_scope')}
            placeHolderText={t('case:placeholders.selectAnOption')}
            selectOptionData={SelectOptionsArrayMapper(savingsOptions.maintenance_scope)}
          />
        </div>
      </div>
    </section>
  );
};
